import React, { Component } from 'react';
import { toast } from 'react-toastify';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    toast.error(`Oops! Something went wrong: ${error.toString()}`);
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
